<template>
  <div
    class='theme-numeric__field-holder'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--focused': isFocused,
      'theme-input__field-holder--readonly': isReadonly,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='label'>
      {{ label }}
    </label>
    <div class='theme-numeric__input-wrapper'>
      <vue-numeric
        :class="['theme-input',
        {
          'theme-input--extra': IsExtraInfo,
        }]"
        :placeholder='placeholder'
        v-model='model'
        :minus='true'
        :name='name'
        :precision='precision'
        thousand-separator
        decimal-separator=','
        @change="$emit('change', $event)"
        :readonly='isReadonly'
        @blur="
          $emit('blur', $event);
          isFocused = false;
        "
        @focus="
          $emit('focus', $event);
          isFocused = true;
        "
      >
      </vue-numeric>
      <div class='theme-input__extra-info' v-show='IsExtraInfo'>
        <slot name='extra-info'></slot>
      </div>
      <span class='icon-warning theme-input__icon theme-input__icon-error' v-if='errors.has(newName)'>
        {{ errors.first(newName) }}
      </span>
    </div>
  </div>
</template>

<script>
  import field from '../admin/mixins/field';
  import VueNumeric from 'vue-numeric';

  export default {
    data() {
      return {
        isFocused: false,
      };
    },
    mixins: [field],
    components: {
      VueNumeric,
    },
    props: {
      precision: {
        default: () => 2,
        type: Number,
      },
      IsExtraInfo: {
        default: false,
        type: Boolean,
      },
      isReadonly: {
        default: false,
        type: Boolean,
      },
      placeholder: {
        default: '',
        type: String,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeNumeric.vue